import React, { useEffect } from "react";

const overlayStyle = {
  position: "fixed",
  inset: 0,
  background: "rgba(0, 0, 0, 0.5)",
  zIndex: 1050,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  padding: "24px",
};

const boxStyle = {
  background: "#fff",
  borderRadius: "6px",
  width: "100%",
  maxHeight: "85vh",
  display: "flex",
  flexDirection: "column",
  boxShadow: "0 8px 30px rgba(0, 0, 0, 0.3)",
};

// Generic large-view modal: an overlay + header (title, optional extra
// header controls, close button) + scrollable body. JsonModal and any
// "view bigger" affordance on a card share this instead of each rolling
// their own overlay chrome.
const Modal = ({ open, onClose, title, headerExtra, children, maxWidth = "900px" }) => {
  useEffect(() => {
    if (!open) return undefined;

    const onKeyDown = (e) => {
      if (e.key === "Escape") onClose();
    };
    document.addEventListener("keydown", onKeyDown);
    return () => document.removeEventListener("keydown", onKeyDown);
  }, [open, onClose]);

  if (!open) return null;

  return (
    <div style={overlayStyle} onMouseDown={onClose}>
      <div style={{ ...boxStyle, maxWidth }} onMouseDown={(e) => e.stopPropagation()}>
        <div className="d-flex justify-content-between align-items-center px-3 py-2 border-bottom">
          <h6 className="mb-0">{title}</h6>
          <div className="d-flex align-items-center" style={{ gap: "8px" }}>
            {headerExtra}
            <button type="button" className="btn-close" aria-label="Close" onClick={onClose} />
          </div>
        </div>
        <div style={{ overflow: "auto", flex: 1 }}>{children}</div>
      </div>
    </div>
  );
};

export default Modal;
